import { IGetPdfUsageTableDataParams, IPdfUsageTableData } from "./PdfTableView.interfaces";


const getPdfUsageTableData = ({ pdfUsages }: IGetPdfUsageTableDataParams): IPdfUsageTableData[] => {
  return pdfUsages.map(
    ({ apiKey, count, date, dateLocaleDateString, url }): IPdfUsageTableData => {
      const { id } = apiKey
      return {
        id,
        apiKey,
        count,
        date,
        dateLocaleDateString,
        url,
      }
    },
  );
};

export { getPdfUsageTableData };
